import React from 'react';
import { Award, Users, Globe, TrendingUp } from 'lucide-react';

export const ExperienceSection = ({ t }) => {
  const features = [
    {
      icon: Award,
      title: 'Calidad Farmacéutica',
      description: 'Productos certificados bajo estándares internacionales',
      image: 'https://images.pexels.com/photos/2280571/pexels-photo-2280571.jpeg'
    },
    {
      icon: Users,
      title: 'Profesionales Certificados',
      description: 'Red global de médicos y especialistas capacitados',
      image: 'https://images.pexels.com/photos/19963193/pexels-photo-19963193.jpeg'
    },
    {
      icon: Globe,
      title: 'Presencia Internacional',
      description: 'Comercialización en más de 15 países alrededor del mundo',
      image: 'https://images.pexels.com/photos/14797863/pexels-photo-14797863.jpeg'
    },
    {
      icon: TrendingUp,
      title: 'Innovación Continua',
      description: 'Investigación y desarrollo de nuevas formulaciones',
      image: 'https://images.pexels.com/photos/356040/pexels-photo-356040.jpeg'
    }
  ];

  return (
    <section id="experience" className="py-24 bg-gradient-to-b from-white to-gray-50 relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-slate-200/30 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-blue-500/5 rounded-full blur-3xl"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Header */}
        <div className="text-center mb-16 space-y-4">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900">
            {t.experience.title}
          </h2>
          <p className="text-xl text-slate-700 font-semibold">
            {t.experience.subtitle}
          </p>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            {t.experience.description}
          </p>
        </div>

        {/* Features Grid with Images */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-20">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div
                key={index}
                className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-3"
              >
                {/* Image Background */}
                <div className="absolute inset-0 z-0">
                  <img 
                    src={feature.image} 
                    alt={feature.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/80 to-gray-900/40 group-hover:from-slate-800 group-hover:via-slate-800/90 transition-all duration-500"></div>
                </div>
                
                {/* Content */}
                <div className="relative z-10 p-8 h-64 flex flex-col justify-end">
                  <div className="w-14 h-14 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center mb-4 group-hover:bg-white transition-all duration-300">
                    <Icon className="w-7 h-7 text-white group-hover:text-slate-800 transition-colors duration-300" />
                  </div>
                  <h3 className="text-xl font-bold text-white mb-3">
                    {feature.title}
                  </h3>
                  <p className="text-white/90 leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        {/* Company Values */}
        <div className="relative rounded-2xl overflow-hidden shadow-xl border border-slate-200">
          <div className="absolute inset-0 bg-gradient-to-r from-slate-800 via-slate-700 to-slate-800"></div>
          <div className="relative z-10 p-12 text-white">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
              <div className="space-y-4 p-6 rounded-xl bg-white/5 backdrop-blur-sm hover:bg-white/10 transition-all duration-300">
                <div className="text-6xl font-bold">01</div>
                <h3 className="text-2xl font-bold">Seguridad</h3>
                <p className="text-white/90">Máximos estándares de calidad y seguridad en cada producto</p>
              </div>
              <div className="space-y-4 p-6 rounded-xl bg-white/5 backdrop-blur-sm hover:bg-white/10 transition-all duration-300">
                <div className="text-6xl font-bold">02</div>
                <h3 className="text-2xl font-bold">Innovación</h3>
                <p className="text-white/90">Investigación constante para ofrecer las mejores soluciones</p>
              </div>
              <div className="space-y-4 p-6 rounded-xl bg-white/5 backdrop-blur-sm hover:bg-white/10 transition-all duration-300">
                <div className="text-6xl font-bold">03</div>
                <h3 className="text-2xl font-bold">Resultados</h3>
                <p className="text-white/90">Eficacia comprobada y satisfacción garantizada</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};